import rosettaSdk, { Campaign } from "@product/rosetta-sdk";
import { useAtomValue } from "jotai";
import { useCallback, useMemo } from "react";

import { useCurrentPageType } from "shared/hooks";
import { PageType } from "shared/lib/page-type";

import { useTakeoverBottomAdSlot } from "scmp-app/components/advertisement/takeover-ad-slot/hooks";
import { gdprAtom } from "scmp-app/components/gdpr-banner/atoms";
import { rosettaAtom } from "scmp-app/lib/rosetta";
import { useRosettaCampaign } from "scmp-app/lib/rosetta/hooks/rosetta-campaign";

export const useRosettaCampaignPopup = () => {
  const { isAccepted: isAcceptedGDPR } = useAtomValue(gdprAtom);
  const asyncRosettaState = useAtomValue(rosettaAtom);
  const currentPageType = useCurrentPageType();
  const { isEnableTakeoverBottomAdSlot } = useTakeoverBottomAdSlot({
    variant: "home",
  });

  const registerRosettaCampaignPopupService = useCallback(() => {
    if (currentPageType !== PageType.Homepage) return;

    rosettaSdk.registerService("campaignPopUp");
    rosettaSdk.getService("campaignPopUp")?.addCampaignPopUpScript();
  }, [currentPageType]);

  const { getActiveCampaignSettings } = useRosettaCampaign();

  const needToShow = useMemo(() => {
    const activeCampaignSettings = getActiveCampaignSettings();
    if (!activeCampaignSettings) return false;

    const campaignPopupSettings = Campaign.getCampaignPopupSettings(activeCampaignSettings);
    if (!campaignPopupSettings || asyncRosettaState?.result?.user?.isInternalStaff === true) {
      return false;
    }

    return !!(
      campaignPopupSettings.checkShouldShowCampaignPopupByDisplayInterval?.() &&
      isAcceptedGDPR &&
      PageType.Homepage === currentPageType &&
      !isEnableTakeoverBottomAdSlot
    );
  }, [
    currentPageType,
    isAcceptedGDPR,
    isEnableTakeoverBottomAdSlot,
    getActiveCampaignSettings,
    asyncRosettaState?.result?.user?.isInternalStaff,
  ]);

  return {
    registerRosettaCampaignPopupService,
    shouldShowRosettaCampaignPopup: needToShow,
  };
};
